import { defineComponent as _defineComponent } from 'vue'

  import Modal from "@/components/ui/Modal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalWithHeader',
  props: {
    isOpen: { type: Boolean, default: false },
    showClose: { type: Boolean, default: true },
    showContainer: { type: Boolean, default: true },
    classes: { type: String, default: "" },
    transitionName: { type: String, default: "fade" },
    maxWidth: { type: Boolean, default: false },
  },
  emits: ["close", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }
  function confirm() {
    emits("confirm");
  }

const __returned__ = { emits, props, close, confirm, Modal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})